import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-label-type',
  templateUrl: './label-type.component.html',
  styleUrls: ['./label-type.component.scss'],
  standalone: false,
})
export class LabelTypeComponent extends FieldType<FieldTypeConfig> {}
